/*
 * @Author: huangtian1_v 1246562955@qq.com
 * @Date: 2024-07-27 12:40:22
 * @LastEditors: huangtian1_v 1246562955@qq.com
 * @LastEditTime: 2025-04-26 16:52:32
 * @FilePath: \eshop_activity\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import VueRouter from 'vue-router';
import Vue from 'vue';
Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  base: '/activity',
  routes: [
    {
      //首页
      path: '/',
      redirect: '/double11',
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    {
      path: '/bundleForm',
      name: 'bundleForm',
      component: (resolve) => {
        require(['@/views/common/bundleForm'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    {
      path: '/bundleResult/:id',
      name: 'bundleResult',
      component: (resolve) => {
        require(['@/views/common/bundleResult'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 申请edu邮箱
    {
      path: '/applyEduEmail',
      name: 'applyEduEmail',
      component: (resolve) => {
        require(['@/views/common/applyEduEmail'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 微信签约
    {
      path: '/wechat-signing',
      name: 'wechatSigning',
      component: (resolve) => {
        require(['@/views/common/wechatSigning'], resolve);
      },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 支付宝签约
    {
      path: '/alipay-signing',
      name: 'alipaySigning',
      component: () => import('@/views/common/wechatSigning/alipaySigning.vue'),
      meta: {
        title: '支付宝签约',
        auth: false
      }
    },
    // 活动下线转到目前活动(中秋活动)
    // {
    //   path: '/student',
    //   name: 'student',
    //   component: (resolve) => {
    //     require(['@/views/students'], resolve);
    //   },
    //   meta: {
    //     isHeader: true,
    //     isFooter: true
    //   }
    // },
    {
      path: '/portin',
      name: 'portin',
      redirect: '/',
      // component: (resolve) => {
      //   require(['@/views/portin'], resolve);
      // },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // visa活动
    {
      path: '/visa',
      name: 'visa',
      component: (resolve) => {
        require(['@/views/visa'], resolve);
      },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 活动下线转到目前活动
    {
      path: '/sales',
      name: 'yearend',
      redirect: '/',
      // component: (resolve) => {
      //   require(['@/views/yearEnd'], resolve);
      // },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 抽奖活动 2024-11-08
    {
      path: '/lottery',
      name: 'lottery',
      redirect: '/',
      // component: (resolve) => {
      //   require(['@/views/lottery'], resolve);
      // },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    {
      path: '/lottery/bundleForm',
      name: 'LotteryForm',
      component: (resolve) => {
        require(['@/views/lottery/bundleForm'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 美国流量卡活动 2025-09-25
    {
      path: '/usdatasim',
      name: 'card',
      component: (resolve) => {
        require(['@/views/card'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 黑五活动
    {
      path: '/black-friday',
      name: 'BlackFriday',
      component: (resolve) => {
        require(['@/views/blackFriday'], resolve);
      },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 圣诞节活动
    {
      path: '/Christmas-day',
      name: 'ChristmasDay',
      beforeEnter: () => {
        window.location.href = 'https://www.encmobile.com';
      },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 升级卡活动
    {
      path: '/upgrade-card',
      name: 'UpgradeCard',
      component: (resolve) => {
        require(['@/views/upgradeCard'], resolve);
      },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 新春活动
    {
      path: '/newyear',
      name: 'SpringFestival',
      beforeEnter: (to, from, next) => {
        window.location.href = 'https://www.encmobile.com';
      },
      // component: (resolve) => {
      //   require(['@/views/SpringFestival/step1/index.vue'], resolve);
      // },

      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    {
      path: '/newyear/operate',
      name: 'SpringFestivalOperate',
      component: (resolve) => {
        require(['@/views/SpringFestival/step2/index.vue'], resolve);
      },
      meta: {
        isHeader: true,
        isFooter: true
      }
    },
    // 新春活动支付页面
    {
      path: '/newyear/bundleForm',
      name: 'SpringFestialBundleForm',
      component: (resolve) => {
        require(['@/views/SpringFestival/bundleForm/index.vue'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 新春活动支付结果页面
    {
      path: '/newyear/bundleResult/:id',
      name: 'SpringFestivalBundleResult',
      component: (resolve) => {
        require(['@/views/SpringFestival/bundleResult/index.vue'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 正式学生活动2026
    {
      path: '/studentoffer',
      name: 'studentoffer',
      component: (resolve) => {
        require(['@/views/students/index.vue'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 预热学生活动2026 5月20日上正式
    {
      path: '/students',
      name: 'students',
      beforeEnter: () => {
        window.location.href = 'https://www.encmobile.com';
      },
      // component: (resolve) => {
      //   require(['@/views/students/index.vue'], resolve);
      // },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    {
      path: '/students/bundleForm',
      name: 'studentsForm',
      component: (resolve) => {
        require(['@/views/students2026/bundleForm'], resolve);
      },
      meta: {
        isHeader: false,
        isFooter: true
      }
    },
    // 双十一活动
    {
      path: '/double11',
      name: 'double11',
      component: (resolve) => {
        require(['@/views/double11/index.vue'], resolve);
      },
      beforeEnter: (to, from, next) => {
        // 仅正式域名限制访问时段:美西 2026-11-02 00:00:00 ~ 2026-11-12 23:59:59,其余时间回官网首页;其他域名(测试/预发)不限制
        if (window.location.hostname !== 'www.encmobile.com') return next();
        // 窗口期内均为冬令时(PST,-08:00)
        const start = new Date('2026-11-02T00:00:00-08:00').getTime();
        const end = new Date('2026-11-12T23:59:59-08:00').getTime();
        const now = Date.now();
        if (now >= start && now <= end) return next();
        window.location.href = 'https://www.encmobile.com';
      },
      meta: {
        isHeader: false,
        isFooter: false
      }
    },
    {
      path: '*',
      component: () => import('@/views/error'),
      meta: {
        title: 'Page Not Found'
      }
    }
  ]
});

export default router;
